'use strict';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Top = void 0;
var $ = require("jquery");
var Vivus = require("vivus");
var Top = /** @class */ (function () {
    function Top() {
        // TOPのアニメーションをさせない
        this.isDebug = false;
        this.chars = '!<>-_\\\\/[]{}—=+*^?#________';
        this.animationFrame03 = 0;
        this.animationFrame04 = 0;
        this.animationFrame05 = 0;
        this.animationQueue03 = [];
        this.animationQueue04 = [];
        this.animationQueue05 = [];
        if ($('.bulletAnimationLogo').length) {
            var urlHash = location.hash;
            if (!urlHash) {
                this.switchScroll(false);
                this.scrollTop();
            }
            if (this.isDebug || urlHash) {
                $('.bulletMainVisual01').hide();
                $('.bulletMainVisual02').hide();
                $('.bulletMainVisual03Animation02').show();
                $('.bulletMainVisual03Animation03').show();
                this.switchScroll(true);
            }
            else {
                this.animationSetText02();
                this.initSvgAnimation();
                this.initCopy();
                this.initAnimation();
            }
        }
    }
    // SVGアニメーションを初期化
    Top.prototype.initSvgAnimation = function () {
        var options = {
            duration: 80,
            start: 'autostart',
            type: 'delayed'
        };
        this.animationSvgBuilding = new Vivus('bulletAnimationSvgBuilding', options, function () { });
        this.animationSvgBuilding.stop();
    };
    // 文字が切り替わるアニメーションの初期セット
    Top.prototype.initCopy = function () {
        var copy03 = $('.bulletCopy03').attr('data-before-text');
        $('.bulletCopy03').html(copy03);
        var copy04 = $('.bulletCopy04').attr('data-before-text');
        $('.bulletCopy04').html(copy04);
        var copy05 = $('.bulletCopy05').attr('data-before-text');
        $('.bulletCopy05').html(copy05);
    };
    // アニメーション初期化
    Top.prototype.initAnimation = function () {
        var _this = this;
        var sleep = function (time) { return new Promise(function (resolve) { return setTimeout(resolve, time); }); };
        var startAnimation = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, sleep(1000)];
                    case 1:
                        _a.sent();
                        $('.bulletAnimationLogo').fadeIn(2000);
                        return [4 /*yield*/, sleep(3000)];
                    case 2:
                        _a.sent();
                        $('.bulletMainVisual01').fadeOut(1000);
                        return [4 /*yield*/, sleep(1000)];
                    case 3:
                        _a.sent();
                        $('.bulletMainVisual02BackgroundImage').fadeIn(1000);
                        return [4 /*yield*/, sleep(1000)];
                    case 4:
                        _a.sent();
                        $('.bulletCopy01').animate({ 'opacity': 1 }, 1000);
                        return [4 /*yield*/, sleep(1000)];
                    case 5:
                        _a.sent();
                        $('.bulletCopy02').animate({ 'opacity': 1 }, 1000);
                        return [4 /*yield*/, sleep(1000)];
                    case 6:
                        _a.sent();
                        $('.bulletCopy06').animate({ 'opacity': 1 }, 1000);
                        return [4 /*yield*/, sleep(4000)];
                    case 7:
                        _a.sent();
                        $('.bulletMainVisual02').fadeOut(1000);
                        return [4 /*yield*/, sleep(1000)];
                    case 8:
                        _a.sent();
                        this.switchScroll(true);
                        this.animationSvgBuilding.play();
                        return [4 /*yield*/, sleep(1000)];
                    case 9:
                        _a.sent();
                        $('.bulletMainVisual03Animation02').fadeIn(1000);
                        this.animationCopy03 = function () { _this.update03(); };
                        this.animationCopy04 = function () { _this.update04(); };
                        this.animationCopy05 = function () { _this.update05(); };
                        this.animationId03 = setInterval(this.animationCopy03, 30);
                        this.animationId04 = setInterval(this.animationCopy04, 30);
                        this.animationId05 = setInterval(this.animationCopy05, 30);
                        return [4 /*yield*/, sleep(8000)];
                    case 10:
                        _a.sent();
                        $('.bulletMainVisual03Animation03').fadeIn(1000);
                        return [2 /*return*/];
                }
            });
        }); };
        startAnimation();
    };
    Top.prototype.animationSetText02 = function () {
        var oldText03 = $('.bulletCopy03').attr('data-before-text');
        var newText03 = $('.bulletCopy03').attr('data-after-text');
        var oldText04 = $('.bulletCopy04').attr('data-before-text');
        var newText04 = $('.bulletCopy04').attr('data-after-text');
        var oldText05 = $('.bulletCopy05').attr('data-before-text');
        var newText05 = $('.bulletCopy05').attr('data-after-text');
        var length03 = Math.max(oldText03.length, newText03.length);
        for (var i = 0; i < length03; i++) {
            var from = oldText03[i] || '';
            var to = newText03[i] || '';
            var start = Math.floor(Math.random() * 40);
            var end = start + Math.floor(Math.random() * 40);
            this.animationQueue03.push({ from: from, to: to, start: start, end: end });
        }
        var length04 = Math.max(oldText04.length, newText04.length);
        for (var i = 0; i < length04; i++) {
            var from = oldText04[i] || '';
            var to = newText04[i] || '';
            var start = Math.floor(Math.random() * 40);
            var end = start + Math.floor(Math.random() * 40);
            this.animationQueue04.push({ from: from, to: to, start: start, end: end });
        }
        var length05 = Math.max(oldText05.length, newText05.length);
        for (var i = 0; i < length05; i++) {
            var from = oldText05[i] || '';
            var to = newText05[i] || '';
            var start = Math.floor(Math.random() * 40);
            var end = start + Math.floor(Math.random() * 40);
            this.animationQueue05.push({ from: from, to: to, start: start, end: end });
        }
    };
    Top.prototype.update03 = function () {
        var output = '';
        var complete = 0;
        for (var i = 0, j = this.animationQueue03.length; i < j; i++) {
            var _a = this.animationQueue03[i], from = _a.from, to = _a.to, start = _a.start, end = _a.end, char = _a.char;
            if (this.animationFrame03 >= end) {
                complete++;
                output += to;
            }
            else if (this.animationFrame03 >= start) {
                if (!char || Math.random() < 0.28) {
                    char = this.randomChar();
                    this.animationQueue03[i].char = char;
                }
                output += "<span class=\"changing\">".concat(char, "</span>");
            }
            else {
                output += from;
            }
        }
        $('.bulletCopy03').html(output);
        if (complete === this.animationQueue03.length) {
            clearInterval(this.animationId03);
        }
        else {
            this.animationFrame03++;
        }
    };
    Top.prototype.update04 = function () {
        var output = '';
        var complete = 0;
        for (var i = 0, j = this.animationQueue04.length; i < j; i++) {
            var _a = this.animationQueue04[i], from = _a.from, to = _a.to, start = _a.start, end = _a.end, char = _a.char;
            if (this.animationFrame04 >= end) {
                complete++;
                output += to;
            }
            else if (this.animationFrame04 >= start) {
                if (!char || Math.random() < 0.28) {
                    char = this.randomChar();
                    this.animationQueue04[i].char = char;
                }
                output += "<span class=\"changing\">".concat(char, "</span>");
            }
            else {
                output += from;
            }
        }
        $('.bulletCopy04').html(output);
        if (complete === this.animationQueue04.length) {
            clearInterval(this.animationId04);
        }
        else {
            this.animationFrame04++;
        }
    };
    Top.prototype.update05 = function () {
        var output = '';
        var complete = 0;
        for (var i = 0, j = this.animationQueue05.length; i < j; i++) {
            var _a = this.animationQueue05[i], from = _a.from, to = _a.to, start = _a.start, end = _a.end, char = _a.char;
            if (this.animationFrame05 >= end) {
                complete++;
                output += to;
            }
            else if (this.animationFrame05 >= start) {
                if (!char || Math.random() < 0.28) {
                    char = this.randomChar();
                    this.animationQueue05[i].char = char;
                }
                output += "<span class=\"changing\">".concat(char, "</span>");
            }
            else {
                output += from;
            }
        }
        $('.bulletCopy05').html(output);
        if (complete === this.animationQueue05.length) {
            clearInterval(this.animationId05);
        }
        else {
            this.animationFrame05++;
        }
    };
    // ランダム文字の生成
    Top.prototype.randomChar = function () {
        return this.chars[Math.floor(Math.random() * this.chars.length)];
    };
    //
    Top.prototype.scrollTop = function () {
        $("html, body").animate({ scrollTop: 0 }, 1000, "linear");
    };
    Top.prototype.switchScroll = function (isScroll) {
        if (isScroll) {
            $('html, body').css({ overflow: 'auto' });
        }
        else {
            $('html, body').css({ overflow: 'hidden' });
        }
    };
    return Top;
}());
exports.Top = Top;
exports.default = Top;
